export const isSecondaryCustomer = (jointOwners) => jointOwners?.some(jointOwner => jointOwner.relationshipType === 'CREATED_FROM') || false;
